import $ from 'domtastic'




/* RADIO TOGGLE
----------------------------------------------------------------------------------------------------*/

export default class RadioToggle {

    constructor($el) {
        this.$els = {
            ctn    : $el,
            items  : $el.find('.js-toggleSection'),
            radios : $el.find('.formRadio'),
        }


        this.bindEvents()

        // display right form on load
        const checkedRadio = Array.from(this.$els.radios).find(r => r.checked)
        if (checkedRadio) {
            this.displayForm(checkedRadio.value)
        }
    }


    bindEvents() {
        this.$els.radios.on('change', (e) => {
            const val = e.target.value
            this.displayForm(val)
        })
    }




    /* Handlers
    --------------------------------------------------------- */




    /* Actions
    --------------------------------------------------------- */
    displayForm(val) {
        const $nextSection = $(`#${val}`)

        this.$els.items.addClass('is-hidden')

        $nextSection.removeClass('is-hidden')
    }



    /* Values
    --------------------------------------------------------- */

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



